<template>
    <div
        :class="`is--${type}`"
        class="widgets-add-limit-alert rounded p-2.5 main-text-color break-keep"
    >
        <div class="flex items-center gap-2 font-medium">
            <div class="w-10 h-10 flex-center">
                <redesign-base-icon
                    :name="ICONS[type]"
                    :size="24"
                    class="alert-icon"
                />
            </div>
            <div class="text-sm">
                <slot />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import RedesignBaseIcon from '@/components/RedesignBaseComponents/RedesignBaseIcon.vue'

const ICONS = {
    error: 'AlertCircle',
    warning: 'AlertTriangle'
}

defineProps<{
    type: 'error' | 'warning'
}>()
</script>

<style lang="scss">
    .widgets-add-limit-alert {
        &.is--error {
            @apply bg-red-100;
            .alert-icon {
                @apply text-red;
            }
        }
        &.is--warning {
            @apply bg-orange-100;
            .alert-icon {
                @apply text-orange;
            }
        }
    }
</style>
